"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ClassLib = require("classnames");
var Checkbox = function (_a) {
    var category = _a.category, name = _a.name, id = _a.id, checked = _a.checked, title = _a.title, onChange = _a.onChange, disabled = _a.disabled, _b = _a.modifierClass, modifierClass = _b === void 0 ? '' : _b;
    var checkboxClass = ClassLib("vx_checkbox profile_checkbox " + modifierClass, { 'vx_is-disabled': disabled });
    return (React.createElement("div", { className: checkboxClass },
        React.createElement("input", { type: "checkbox", name: name, "data-category": category, id: id, checked: checked, title: title, disabled: disabled, onChange: onChange }),
        React.createElement("label", { htmlFor: id, className: "fiLabel" })));
};
exports.default = Checkbox;
